// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__uCx2D","main-wrapper":"Layout_main-wrapper__5WYfo","main-content":"Layout_main-content__SVQpi"};